import React from 'react'
import classNames from 'classnames'

import differenceInDays from 'date-fns/differenceInDays';
import endOfMonth from 'date-fns/endOfMonth';
import endOfWeek from 'date-fns/endOfWeek';

import Day from '../Day';

const baseHeight = 2;

export default function Week({
    selectedDates,
    onSelect,
    onChange,
    schedule,
    month,
    days,
    hasSchedule,
    index
}) {

    const missing = index === 0 && 7 - days?.length;

    const firstDayOfWeek = days[0].date;
    let lastDayOfWeek = endOfWeek(days[0].date, { weekStartsOn: 1 });
    const lastDayOfMonth = endOfMonth(month)
    if(lastDayOfMonth < lastDayOfWeek) {
        lastDayOfWeek = lastDayOfMonth;
    }

    const thisSchedule = schedule?.filter((scheduleItem) => {
        return scheduleItem.fromDate <= lastDayOfWeek && scheduleItem.toDate >= firstDayOfWeek
    })

    const WeekClasses = classNames({
        "ola-week relative flex flex-wrap box-border": true,
        "border-t border-gray": hasSchedule,
        "px-4": !hasSchedule,
    })

    return (
        <div className={WeekClasses}>

            {!!missing && Array.from(Array(missing).keys()).map((i) => 
                <div key={i} className="ola-day empty" style={{width: 'calc(100% / 7)'}}></div>
            )}

            {thisSchedule?.length > 0 &&
                <div className="ola-events-list absolute top-8 left-0 w-full">
                    {thisSchedule?.map((scheduleItem) => {

                        let startDay = scheduleItem.fromDate;
                        let endDay = scheduleItem.toDate;

                        const hasCheckin = startDay >= firstDayOfWeek;
                        const hasCheckout = endDay <= lastDayOfWeek;

                        if (startDay < firstDayOfWeek) {
                            startDay = firstDayOfWeek;
                        }
                        if (endDay > lastDayOfWeek) {
                            endDay = lastDayOfWeek;
                        }

                        const duration = differenceInDays(endDay, startDay) + 1;
                        const offset = differenceInDays(startDay, firstDayOfWeek);

                        const ContentClasses = classNames({
                            "ola-events-item relative z-1 text-xs text-white flex items-center px-2": true,
                            "rounded-l-lg": hasCheckin,
                            "rounded-r-lg": hasCheckout,
                            "bg-primary": !scheduleItem.color,
                            [`bg-${scheduleItem.color}`]: scheduleItem.color,
                        })

                        return (
                            <div
                                key={scheduleItem._id}
                                className={ContentClasses}
                                style={{
                                    marginTop: '1px',
                                    height: `calc(${baseHeight}rem - 2px)`,
                                    width: `${100 / 7 * duration}%`,
                                    left: `${100 / 7 * (offset + missing)}%`
                                }}
                            >
                                {scheduleItem.title}
                            </div>
                        )
                    })}
                </div>
            }

            {days.map((day) => {
                return (
                    <Day
                        key={day.date}
                        day={day}
                        selectedDates={selectedDates}
                        onSelect={onSelect}
                        onChange={onChange}
                        hasSchedule={hasSchedule}
                        scheduleLength={thisSchedule?.length}
                    />
                )
            })}
        </div>
    )
}
